module.exports = __webpack_public_path__ + "static/img/blog-3.e166f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog-3.png
// module id = 5Vp+
// module chunks = 1